import { render, staticRenderFns } from "./Suppliers.vue?vue&type=template&id=227c3848&scoped=true&"
import script from "./Suppliers.vue?vue&type=script&lang=ts&"
export * from "./Suppliers.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "227c3848",
  null
  
)

export default component.exports